export default "__VITE_ASSET__BW8BExwF__"